import React from "react";
import InternalLink from "../InternalLink";
import { Button } from "../../sdk/Button";
import { Section } from "../../sdk/Layout";
import { Wrapper, Content, Text, Cover } from "./style";
import Icons from "../Icons2";

function SliderC({ config }) {
    if (config == null || config.length === 0) return null;
    return (
        <Section>
            <Wrapper isFluid>
                <Content>
                    <Text isNarrow>
                        {config[0].logo &&
                        config[0].logo.img &&
                        config[0].logo.img.length > 0 ? (
                            <img
                                src={config[0].logo.img[0]}
                                alt={config[0].altlogo}
                            />
                        ) : null}
                        <p>{config[0].paragraph}</p>
                        {config[0].link1 ? (
                            <InternalLink {...config[0].link1} target="_blank">
                                <Button small>
                                    <span>{config[0].cta1}</span>{" "}
                                    <Icons icon="external-link"></Icons>
                                </Button>
                            </InternalLink>
                        ) : null}
                    </Text>
                    <Cover>
                        <img
                            src={config[0].img.img[0]}
                            alt={config[0].altimg}
                        />
                    </Cover>
                </Content>
            </Wrapper>
        </Section>
    );
}

export default SliderC;
